module.exports = __webpack_public_path__ + "static/Vilva-Athiban-a9a6306ffd60fab5e0ed9e1131b1af1f.png";